import { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';
import { Fireworks } from 'fireworks-js';
import './App.css';

const palabrasProhibidas = [
  "mierda", "puta", "puto", "maldito", "estúpido", "idiota", "imbécil", "pendejo",
  "cabron", "chingar", "chingado", "perra", "coño", "culero", "joder", "negro", "nigga",
  "cerote", "pizado", "vergudo", "verga", "caca", "gay", "homosexual", "carechimba", "wey"
];

const DOMINIO_CORPORATIVO = '@grupotritech.com';

function App() {
  const [nombre, setNombre] = useState('');
  const [habilidad, setHabilidad] = useState('');
  const [email, setEmail] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState('');

  const fireworksRef = useRef(null);
  const celebrationRef = useRef(null);
  const fwInstance = useRef(null);
  const celebrationInstance = useRef(null);

  useEffect(() => {
    if (fireworksRef.current) {
      const options = {
        speed: 1,
        acceleration: 1.05,
        friction: 0.97,
        gravity: 1.9,
        particles: 150,
        trace: 0,
        explosion: 5,
        intensity: 20,
        flickering: 50,
        opacity: 0.2,
        lineWidth: { explosion: [1, 3] },
      };
      fwInstance.current = new Fireworks(fireworksRef.current, options);
      fwInstance.current.start();
    }
  }, []);

  const triggerCelebration = () => {
    if (celebrationRef.current) {
      if (celebrationInstance.current) {
        celebrationInstance.current.stop();
      }

      const options = {
        speed: 2,
        acceleration: 1,
        friction: 0.99,
        gravity: 1.9,
        particles: 190,
        trace: 1,
        explosion: 8,
        intensity: 30,
        flickering: 80,
        opacity: 1,
        lineWidth: { explosion: [1, 8] },
      };
      celebrationInstance.current = new Fireworks(celebrationRef.current, options);
      celebrationInstance.current.start();

      setTimeout(() => {
        celebrationInstance.current.stop();
      }, 9000);
    }
  };

  const normalizarTexto = (texto) =>
    texto.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, '');

  const contienePalabrasProhibidas = (texto) => {
    const textoLimpio = normalizarTexto(texto);
    return palabrasProhibidas.some((palabra) =>
      textoLimpio.includes(normalizarTexto(palabra))
    );
  };

  const esCorreoCorporativo = (correo) => {
    return correo.toLowerCase().endsWith(DOMINIO_CORPORATIVO);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!esCorreoCorporativo(email)) {
      setError(`⚠️ Solo se permite el uso de correos corporativos ${DOMINIO_CORPORATIVO} ⚠️`);
      return;
    }

    if (contienePalabrasProhibidas(nombre) || contienePalabrasProhibidas(habilidad)) {
      setError("⚠️ Tu mensaje contiene palabras no permitidas. ⚠️ ");
      return;
    }

    setError('');

    const nombreFormateado = nombre.trim().toUpperCase();
    const habilidadFormateada = habilidad.trim().charAt(0).toUpperCase() + habilidad.trim().slice(1).toLowerCase();

    try {
      const response = await fetch('https://grupotritech.com/guardar_participante.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nombre: nombreFormateado, habilidad: habilidadFormateada, email }),
      });

      const data = await response.json();

      if (!data.success) {
        setError(data.message || 'Este correo ya fue registrado.');
        return;
      }

      const titulo = "Felicidades Papa :";
      const subtitulo = "LO QUE MAS VALORA SU FAMILIA:";

      const overlay = `https://res.cloudinary.com/dkpyw0uwd/image/upload/` +
        `l_text:Montserrat_40_bold:${encodeURIComponent(titulo)},co_rgb:000727,y_560/` +
        `l_text:Montserrat_50_bold:${encodeURIComponent(nombreFormateado)},co_rgb:2164fd,y_620/` +
        `l_text:Montserrat_20_bold:${encodeURIComponent(subtitulo)},co_rgb:000727,y_660/` +
        `l_text:Montserrat_30:${encodeURIComponent(habilidadFormateada)},co_rgb:2164fd,y_720,w_800,c_fit/` +
        `v1747759816/AutoMailTritech_a061mp.png`;

      const templateParams = {
        to_name: nombreFormateado,
        to_email: email,
        message: habilidadFormateada,
        image_url: overlay,
      };

      await emailjs.send(
        'service_cts1mhj',
        'template_hrds76p',
        templateParams,
        'BrIEbBhxrkVL6ATM3'
      );

      triggerCelebration();
      setEnviado(true);
    } catch (error) {
      console.error('Error al enviar:', error);
      setError('Ocurrió un error al procesar tu solicitud. Intenta nuevamente.');
    }
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-black via-slate-900 to-black text-white overflow-hidden flex flex-col items-center justify-start py-12 px-4">
      <div ref={fireworksRef} className="absolute top-0 left-0 w-full h-full z-0"></div>
      <div ref={celebrationRef} className="absolute top-0 left-0 w-full h-full z-50 pointer-events-none"></div>

      <motion.img
        src="https://grupotritech.com/diadelpadre/dadnew.webp"
        alt="Papá flotando"
        className="z-10 w-50 m-[5px]"
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
      />

      <h1 className="text-3xl font-tritech mb-0px z-10">Papás con Historia</h1>
      <p className="text-center font-tritech mb-8 z-10">Celebremos a quienes dejan huella cada día</p>

      {!enviado ? (
        <form
          onSubmit={handleSubmit}
          className="bg-white text-black rounded-xl p-6 w-full max-w-md z-10 shadow-2xl"
        >
          <label className="block mb-2 font-tritech">Nombre del papá</label>
          <input
            type="text"
            maxLength={20}
            value={nombre}
            onChange={(e) =>
              setNombre(
                e.target.value
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .replace(/[^a-zA-Z0-9 ]/g, "")
              )
            }
            className={`w-full p-2 mb-1 border rounded ${error && contienePalabrasProhibidas(nombre) ? 'border-red-500' : ''}`}
            placeholder="Ej. Luis Garcia"
            required
          />
          <p className="text-xs text-gray-500 mb-4">* No se permiten acentos ni caracteres especiales.</p>

          <label className="block mb-2 font-tritech">Mensaje que lo caracteriza</label>
          <input
            type="text"
            maxLength={40}
            value={habilidad}
            onChange={(e) =>
              setHabilidad(
                e.target.value
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .replace(/[^a-zA-Z0-9 ]/g, "")
              )
            }
            className={`w-full p-2 mb-1 border rounded ${error && contienePalabrasProhibidas(habilidad) ? 'border-red-500' : ''}`}
            placeholder="Ej. Siempre da lo mejor por su familia"
            required
          />
          <p className="text-xs text-gray-500 mb-4">* No se permiten acentos ni caracteres especiales.</p>

          <label className="block mb-2 font-tritech">Tu correo corporativo</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 mb-4 border rounded"
            placeholder="Ej. tuemail@grupotritech.com"
            required
          />

          {error && (
            <p className="text-red-600 font-tritech text-sm mb-4">{error}</p>
          )}

          <button
            type="submit"
            className="w-full bg-blue-900 hover:bg-blue-400 text-white py-2 rounded font-tritech"
          >
            Generar y Enviar
          </button>
        </form>
      ) : (
        <div className="text-center font-tritech z-10">
          <h2 className="text-xl font-tritech mb-2">¡Gracias por compartir!</h2>
          <p>El arte personalizado se ha enviado a tu correo. 🎉</p>
        </div>
      )}
    </div>
  );
}

export default App;
